/** @file Dropdown built on the native select element: keyboard, IME and screen readers come for free. */
import './tokens.css';
import './Select.css';
import { joinClass } from './logic/joinClass';

/** One choice; `label` is already-translated text (or an entity name), `value` is the stable key. */
export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

/** Props of Select. */
export interface SelectProps {
  value: string;
  options: readonly SelectOption[];
  onChange: (value: string) => void;
  /** Already-translated accessible name. */
  label: string;
  disabled?: boolean;
  className?: string;
}

/** Controlled dropdown; `onChange` fires with the chosen option's `value`. */
export function Select({ value, options, onChange, label, disabled = false, className }: SelectProps) {
  return (
    <select className={joinClass('p2-select', className)} aria-label={label} value={value} disabled={disabled} onChange={(e) => { onChange(e.currentTarget.value); }}>
      {options.map((option) => (
        <option key={option.value} value={option.value} disabled={option.disabled === true}>{option.label}</option>
      ))}
    </select>
  );
}
